import { Alert, Stack, Typography } from "@mui/joy";
import { useAuth } from "../../contexts/AuthContext";
import { CommissionSettings } from "../../components/commissions/CommissionSettings";
export function CommissionSettingsPage() {
  const { user } = useAuth();
  if (!user?.is_organization_admin && !user?.is_superuser)
    return (
      <Alert color="warning">
        Organization admins manage commission structures.
      </Alert>
    );
  return (
    <Stack gap={3}>
      <div>
        <Typography level="h2">Commission structure</Typography>
        <Typography level="body-md" sx={{ mt: 0.5 }}>
          Build the way your company and sales team share every job.
        </Typography>
      </div>
      <CommissionSettings />
    </Stack>
  );
}
